import UserStore from './UserStore';
import PropertyStore from './PropertyStore';
import PasscodeStore from './PasscodeStore';
import LogStore from './LogStore';

class StoreManager {
  initialize(userId) {
    let promises = [];
    promises.push(UserStore.setUser(userId));
    promises.push(PropertyStore.setUser(userId));
    promises.push(LogStore.setUser(userId));

    return Promise
          .all(promises)
          .then(() => {
            const property = PropertyStore.selectedProperty;
            return PasscodeStore.setProperty(property);
          });
  }

  clear() {
    UserStore.clearUser();
    PropertyStore.clearUser();
    PasscodeStore.clearProperty();
    LogStore.clearUser();
  }
}

const storeManager = new StoreManager();
export default storeManager;


// WEBPACK FOOTER //
// ./src/stores/StoreManager.js